<template>

    <div class="points-allocation-page-container-wrapper defaultShadow">
        <div class="points-allocation-page-container contentBackground">
            <div class="points-allocation-page-item textColor">
                <div class="top-item-container">
                    <img :src="group.logo_url" class="logo" />
                    <div class="logo-points">
                        <h4 class="title" v-html="group.name"></h4>
                        <div class="themeSecondaryColorBackground points">
                            <div class="themePrimaryColor"><i class="fa fa-globe font-weight-bold"></i> &nbsp;{{ lang.get('event_strings.points_allocation_page.group_points').replace("{AMOUNT}",group.points) }}</div>
                        </div>
                    </div>
                    <div class="title-donation">
                        <div class="donation" v-if="searchableGamePointTypes.length > 0">
                            <searchable-dropdown class="point-type-search text-left" v-model="gamePointSelected" @change="gamePointChanged"
                                v-bind:options="searchableGamePointTypes" :default-option="lang.get('event_strings.points_allocation_page.select_game_point_type')">
                            </searchable-dropdown>
                            <a @click="decreasePoints" class="sign"><i class="fas fa-minus font-weight-bold"></i></a>
                            <input class="text-box" type="text" placeholder="0" :size="inputSize" v-model="amount" disabled/>
                            <a @click="increasePoints" class="sign"><i class="fas fa-plus font-weight-bold"></i></a>
                        </div>
                    </div>
                    <div class="text-left">{{ lang.get('event_strings.points_allocation_page.points_used').replace("{AMOUNT}",pointsDonated(group.id)) }}</div>
                </div>
                <button class="donate-btn" @click="donate"><i class="fas fa-heart font-weight-bold"></i> &nbsp;{{ lang.get('event_strings.points_allocation_page.donate') }}</button>
                
                <div class="divider themePrimaryColor" v-if="group.description != null && group.description.length > 0"></div>
                <a class="text-center" @click="activateDescription" v-if="group.description != null && group.description.length > 0">
                    <i class="fas fa-chevron-down font-weight-bold" v-if="!isDescriptionActive"></i>
                    <i class="fas fa-chevron-up font-weight-bold" v-else></i>
                </a>
                <div class="bottom-item-container" v-if="isDescriptionActive">
                    <div class="" v-html="group.description"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import SearchableDropdown from '../../components/global/SearchableDropdown'

export default {
    props: [
        'group',
        'game-point-types',
        'points-used'
    ],

    components: {
        SearchableDropdown
    },

    data() {
        return {
            gamePointSelected: '',
            amount: 0,
            index: -1,
            isDescriptionActive: false
        }
    },

    computed: {
        searchableGamePointTypes: function () {
            var self = this
            var mapped = Object.keys(this.gamePointTypes).map(function (key) {
                return { value: key, text: self.gamePointTypes[key][0].label }
            });
            return mapped;
        },
        inputSize: function () {
            return this.amount == 0 ? 2 : this.amount.toString().length + 1
        }
    },

    methods: {
        pointsDonated(groupdId) {
            var total = 0
            if (this.pointsUsed[groupdId]) {
                this.pointsUsed[groupdId].forEach(point => {
                    total += point.points_result
                });
            }

            return total
        },

        gamePointChanged() {
            if (this.gamePointSelected) {
                this.index = -1
                this.amount = 0
            }
        },
        increasePoints() {
            if (this.gamePointSelected) {
                this.index = Math.min(this.index + 1, this.gamePointTypes[this.gamePointSelected].length);
                if (this.index > -1 && this.index < this.gamePointTypes[this.gamePointSelected].length) {
                     this.amount += this.gamePointTypes[this.gamePointSelected][this.index].points_result;
                }
            }
        },
        decreasePoints() {
            if (this.gamePointSelected) {
                this.index = Math.min(this.index, this.gamePointTypes[this.gamePointSelected].length - 1);
                if (this.index > -1) {
                    this.amount = Math.max(0, this.amount - this.gamePointTypes[this.gamePointSelected][this.index].points_result);
                }
                this.index = Math.max(-1, this.index - 1);
            }
        },

        activateDescription() {
            this.isDescriptionActive = !this.isDescriptionActive
        },

        donate() {
            var gamePointTypes = this.gamePointTypes
            for (let index = 0; index < this.index + 1 && index < gamePointTypes[this.gamePointSelected].length; index++) {
                this.$emit('group-donate', this.group.id, 
                    gamePointTypes[this.gamePointSelected][index].id, 
                    gamePointTypes[this.gamePointSelected][index].game_point_value_id
                )
            }

            this.gamePointSelected = ''
            this.index = -1
            this.amount = 0
        }
    },

    mounted () {
    }
};

</script>